import Axios, { CancelTokenSource, AxiosError } from "axios";
import Api from "src/spintr/SpintrApi";

export function getCancelTokenSource(): CancelTokenSource {
    return Axios.CancelToken.source();
}

export function isOfflineError(err: AxiosError): boolean {
    return err.isAxiosError && err.message === "Network Error";
}

export type EnhancedAxiosError = AxiosError & {
    isOffline?: boolean;
};

export * from "./groupsApi";
export * from "./objectsApi";
export * from "./qualityHubApi";
export * from "./routesApi";
export * from "./samlApi";
export * from "./wikiApi";

export default Api;

